
import { useQuery } from 'react-query';
import { setHeaders } from '../../../utils/basic';
import * as config from '../../../app.config';
import axios from 'axios';


const getQLpStatsForDownload = async (plate_uuid) => {

    const headerConfig = setHeaders();
    const { data } = await axios.get(`${config.ENDPOINTS["datalake"]}/qc/qlp_stats/${plate_uuid}`, {
        headers: headerConfig
    });
    return data?.signedUrl;
};

export default function useFetchQLpStatsForDownload(plate_uuid) {

    return useQuery('QLpStatsForDownload', () => getQLpStatsForDownload(plate_uuid), {
        onSuccess: (data) => {
            // console.log(data);
        },

        onError: (error) => {
            console.log(error);
        },

    });
}


